'use strict';
exports.__esModule = true;
var tree_node_1 = require("./tree-node");
var treewidget;
(function (treewidget) {
    var TreeMaker = /** @class */ (function () {
        function TreeMaker(treeNodes, rootID, showTreeColors) {
            if (treeNodes.length > 0) {
                this.makeMapOfNodes(treeNodes, showTreeColors);
                if (!this.rootID && rootID) {
                    this.rootID = rootID;
                }
                var rootNode = this.nodeMap[this.rootID];
                if (rootNode) {
                    this.jsonTree = this.recursiveTree(rootNode);
                }
            }
        }
        TreeMaker.prototype.makeMapOfNodes = function (treeNodes, showTreeColors) {
            this.rootID = null;
            this.nodeMap = {};
            var colorSchema = {
                latest: '#153a42',
                somewhatNew: '#387684',
                old: '#69b5c7',
                veryOld: 'black'
            };
            for (var i = 0; i < treeNodes.length; i++) {
                var treeNode = new tree_node_1["default"].TreeNode(treeNodes[i]._id, treeNodes[i].name, undefined, [], // children
                treeNodes[i].isPlatform, treeNodes[i].commands);
                // Set those not pre-defined values
                // TODO: Please refactor to call this readonly, and it should be a boolean
                treeNode["permissions"] = treeNodes[i].attribute;
                treeNode["isDataValid"] = treeNodes[i].isDataValid;
                treeNode["role"] = treeNodes[i].role;
                treeNode["description"] = treeNodes[i].description;
                treeNode["acl"] = treeNodes[i].acl;
                treeNode["parentId"] = treeNodes[i].parent ? treeNodes[i].parent[0] : null;
                treeNode["childrenIds"] = treeNodes[i].children;
                treeNode["hasChildren"] = (treeNodes[i].children.length > 0);
                treeNode["tags"] = treeNodes[i].tags || [];
                treeNode["dropdownTags"] = treeNodes[i].dropdownTags || [];
                treeNode["tagString"] = treeNode["tags"].join(',');
                treeNode["chosenGroups"] = treeNodes[i].chosenGroups;
                treeNode["chosenTemplates"] = treeNodes[i].chosenTemplates;
                treeNode["smartText"] = treeNodes[i].smartText;
                treeNode["data"] = treeNodes[i].data;
                treeNode["path"] = treeNodes[i].path;
                treeNode["inavImpactType"] = 'inavImpactType' in treeNodes[i] ? treeNodes[i].inavImpactType : 'Quantitative';
                if ('categoriesConfig' in treeNodes[i]) {
                    treeNode["categoriesConfig"] = treeNodes[i].categoriesConfig;
                }
                treeNode["lastRecalc"] = treeNodes[i].lastRecalc ? treeNodes[i].lastRecalc : '-';
                if ('lastUpdated' in treeNodes[i]) {
                    var lastUpdatedOn = new Date(treeNodes[i].lastUpdated).toISOString().slice(0, 10);
                    var updatedDate = new Date(lastUpdatedOn);
                    var now = new Date();
                    var today = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
                    var currentDate = new Date(today);
                    var diffTime = Math.abs(currentDate - updatedDate);
                    var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    var leafColor = colorSchema.veryOld;
                    if (diffDays < 30) {
                        leafColor = colorSchema.latest;
                    }
                    else if (diffDays < 90) {
                        leafColor = colorSchema.somewhatNew;
                    }
                    else if (diffDays < 180) {
                        leafColor = colorSchema.old;
                    }
                    else if (diffDays >= 180) {
                        leafColor = colorSchema.veryOld;
                    }
                    treeNode["lastUpdated"] = 'lastUpdated' in treeNodes[i] ? treeNodes[i].lastUpdated : null;
                    treeNode["tooltip"] = 'savedBy' in treeNodes[i] ?
                        'Last updated: ' + lastUpdatedOn + '<br>' + 'Saved by: ' + treeNodes[i].savedBy :
                        'Last updated: ' + lastUpdatedOn;
                    if (showTreeColors) {
                        if (!treeNode['hasChildren']) {
                            treeNode["leafColor"] = 'lastUpdated' in treeNodes[i] ? { 'color': leafColor } : null;
                        }
                    }
                }
                this.nodeMap[treeNode["_id"]] = treeNode;
                if (!treeNodes[i].parent) {
                    this.rootID = treeNode._id;
                    this.categoriesConfig = treeNodes[i].categoriesConfig;
                    this.dropdownCategoryConfig = treeNodes[i].dropdownCategoryConfig;
                    if (treeNodes[i].univSchema) {
                        treeNode["univSchema"] = treeNodes[i].univSchema;
                    }
                }
            }
        };
        TreeMaker.prototype.assignChildren = function (treeNode) {
            return this.recursiveTree(treeNode);
        };
        TreeMaker.prototype.assignParent = function (treeNode) {
            // traverse each element of this.nodeMap map
            for (var key in this.nodeMap) {
                var node = this.nodeMap[key];
                if (!node.parent) {
                    node.parent = treeNode;
                }
            }
        };
        TreeMaker.prototype.recursiveTree = function (treeNode) {
            var childArray = [];
            for (var i = 0; i < treeNode.childrenIds.length; i++) {
                var childNodeID = treeNode.childrenIds[i];
                if (childNodeID in this.nodeMap) {
                    var child = this.nodeMap[childNodeID];
                    childArray.push(child);
                    this.recursiveTree(child);
                }
            }
            treeNode.parent = this.nodeMap[treeNode["parentId"]];
            treeNode.children = childArray;
            return treeNode;
        };
        TreeMaker.prototype.recursiveTagsTree = function (treeNode, catsAndTags) {
            for (var i = 0; i < treeNode.childrenIds.length; i++) {
                var childNodeID = treeNode.childrenIds[i];
                if (childNodeID in this.nodeMap) {
                    var child = this.nodeMap[childNodeID];
                    child["tags"] = catsAndTags[childNodeID]['tags'] ? catsAndTags[childNodeID]['tags'] : [];
                    child["dropdownTags"] = catsAndTags[childNodeID]['dropdownTags'] ? catsAndTags[childNodeID]['dropdownTags'] : [];
                    this.recursiveTagsTree(child, catsAndTags);
                }
            }
            return treeNode;
        };
        TreeMaker.prototype.getTagsNodeMap = function (tagsData) {
            var tagsNodeMap = {};
            tagsData.map(function (ct) {
                tagsNodeMap[ct['_id']] = ct;
            });
            this.tagsNodeMap = tagsNodeMap;
            return tagsNodeMap;
        };
        TreeMaker.prototype.appendTagsUsingMap = function (node, tagsNodeMap) {
            var _this = this;
            if (tagsNodeMap[node['_id']]) {
                node.tags = tagsNodeMap[node['_id']].tags;
                node.dropdownTags = tagsNodeMap[node['_id']].dropdownTags;
            }
            node.children = node.children.map(function (child) { return _this.appendTagsUsingMap(child, tagsNodeMap); });
            return node;
        };
        return TreeMaker;
    }());
    treewidget.TreeMaker = TreeMaker;
})(treewidget || (treewidget = {}));
exports["default"] = treewidget;
//# sourceMappingURL=tree-maker.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/app/js/logic/tree-maker.js